

  import Vue from 'vue'
  import Component from "vue-class-component";

  import {Prop, Watch} from "vue-property-decorator";
  import {IServiceProvider} from "@/model/Service/serviceProviderInterfaces";
  import ImageUploader from "@/components/shared/ImageUploader.vue";

  @Component({
    components: {ImageUploader}
  })
  export default class SPImage extends Vue {

    @Prop()
    protected provider!: IServiceProvider;
    @Prop()
    protected title!: string;
    @Prop()
    protected subTitle!: string;
    @Prop()
    protected endpoint!: string;
    @Prop()
    protected src!: string;
    @Prop()
    protected canEdit!: boolean;
    @Prop()
    protected disabled!: boolean;
    @Prop()
    protected alert!: string;

    protected loading: boolean = false;

    protected onImageChanged(newUrl: string) {
      this.$emit('change', newUrl);
    }

    protected onImageZoom() {
      this.$uiBus.emit('info', '' + this.$t('services.provider.onImageZoom'));
    }

  }

